export default __webpack_public_path__ + "static/media/successIcon.fb5e5e91.svg";